import {
  HardFormFieldTypeEnum,
  HardTableColumnTypeEnum,
  IHardFormField,
  IHardFormFieldParams,
  IHardFormInputParams,
} from "@hardcode-kz/ui";
import {
  IBaseConfig,
  IFormFieldFilter,
  ITable,
} from "@models/form/base-config";
import { ResourceManagementEndpoints } from "@app/shared/data-access/src/lib/resource-management/types/resource-management-endpoints";
import { IMaintenancePartner } from "@app/shared/data-access/src/lib/resource-management/models/maintenance-partner";
import { LangEnum } from "@models/interface-management/localization";
import { TranslationFieldPartialValidator } from "@static/fields/fields-constant";
import { Validators } from "@angular/forms";

export class MaintenancePartnerConfig implements IBaseConfig {
  version = 1;
  dicType = ResourceManagementEndpoints.MaintenancePartner;
  isCrudByModal = true;
  title = "dicTable.maintenancePartners";

  fields: IHardFormField[] = [
    {
      name: "name",
      params: {
        direction: "row",
        fields: TranslationFieldPartialValidator(
          "dicTable.name",
          HardFormFieldTypeEnum.Input,
          [LangEnum.RU, LangEnum.KZ, LangEnum.EN],
        ),
      },
    },
    {
      name: "email",
      title: "dicTable.email",
      type: HardFormFieldTypeEnum.Input,
      params: {
        validators: [Validators.required, Validators.email],
      },
    },
    {
      name: "phoneNumber",
      title: "dicTable.number",
      type: HardFormFieldTypeEnum.Input,
      placeholder: "+7 777 777 77 77",
      params: {
        validators: [Validators.required],
        mask: "+0 000 000 00 00",
      } as IHardFormInputParams,
    },

    {
      name: "address",
      title: "dicTable.address",
      type: HardFormFieldTypeEnum.Input,
      params: {
        validators: [Validators.required],
      },
    },
  ];

  filterTemplateColumns = "1fr";

  filterFields: IFormFieldFilter<IHardFormFieldParams>[] = [
    {
      name: "searchTerm",
      type: HardFormFieldTypeEnum.Input,
      placeholder: "base.search",
      outside: true,
    },
  ];

  tableConfig: ITable<IMaintenancePartner[]> = {
    showDefaultActions: true,
    tableColumns: "44px repeat(5,auto)",
    columns: [
      {
        title: "№",
        name: "id",
        type: HardTableColumnTypeEnum.Index,
      },
      {
        title: "dicTable.name",
        name: "name",
        type: HardTableColumnTypeEnum.Translate,
      },
      {
        title: "dicTable.number",
        name: "phoneNumber",
        type: HardTableColumnTypeEnum.Text,
      },
      {
        title: "dicTable.email",
        name: "email",
        type: HardTableColumnTypeEnum.Text,
      },
      {
        title: "dicTable.address",
        name: "address",
        type: HardTableColumnTypeEnum.Text,
      },
    ],
  };
}
